<template>
  <CustomPage title="提现" style="background: #f7f7f7">
    <div slot="content">
      <div class="withdraw-container">
        <!-- <div class="head" @click="actionSheetShow = true"> -->
        <div class="head">
          <div class="label">
            <img :src="require('@/assets/mine/微信钱包.svg')" alt="" />
            <div class="text">
              <div class="tit">微信钱包</div>
              <div class="subtit">微信昵称：{{ wechat_info.nickname }}</div>
            </div>
          </div>
          <div class="value">
            <!-- <img :src="require('@/assets/setting/箭头1.svg')" alt="" /> -->
          </div>
        </div>
        <div class="content">
          <div class="title">提现金额</div>
          <div class="value van-hairline--bottom">
            <Field class="input" v-model="amount" label="¥" />
          </div>
          <div class="tips">
            <span class="count">当前钱包提现金额{{ withdrawAmount }}元,</span>
            <span class="btn" @click="amount = Number(withdrawAmount)"
              >全部提现</span
            >
          </div>
        </div>
        <div class="btn-box">
          <Button
            class="btn"
            :class="{ disable: !amount || amount === 0 }"
            @click="handleClick"
            :loading="loading"
            >提现</Button
          >
        </div>
        <div class="subtips">
          <Icon name="warning-o" class="icon" />每月25—31日可提现
        </div>
      </div>
      <ActionSheet v-model="actionSheetShow" title="选择到账方式">
        <div class="actionsheet-container">
          <div class="head">第三方提现</div>
          <div class="body">
            <div class="panel">
              <div class="img">
                <img :src="require('@/assets/mine/微信钱包.svg')" alt="" />
              </div>
              <div class="value">
                <div class="title">微信钱包</div>
                <div class="desc">请绑定验证您的微信号</div>
              </div>
            </div>
            <div class="panel">
              <div class="img">
                <img :src="require('@/assets/mine/支付宝.svg')" alt="" />
              </div>
              <div class="value">
                <div class="title">支付宝余额</div>
                <div class="desc">请绑定验证您的支付宝账户</div>
              </div>
            </div>
          </div>
        </div>
      </ActionSheet>
      <PayPassword :show.sync="payPasswordShow" @submit="submitForm" />
    </div>
  </CustomPage>
</template>

<script>
import { getBindWechatInfo } from "@/api/login";
import { getWallet, withdraw } from "@/api/wallet";
import CustomPage from "@/components/custom-page.vue";
import { Field, Icon, ActionSheet, Toast, Dialog } from "vant";
import PayPassword from "@/components/PayPassword";
import { payPasswordExists } from "@/api/pay";
export default {
  components: { CustomPage, Field, Icon, ActionSheet, PayPassword },
  data() {
    return {
      wechat_info: {
        nickname: null,
        headImgUrl: null,
      },
      amount: null,
      loading: false,
      actionSheetShow: false,
      payPasswordShow: false,
      withdrawAmount: null,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      try {
        this.$store.dispatch("app/showLoading");
        await this.getWallet();
        await this.getBindWechatInfo();
        this.$store.dispatch("app/hideLoading");
      } catch (error) {
        this.$store.dispatch("app/hideLoading");
      }
    },
    // 获取余额
    getWallet() {
      return new Promise((resolve, reject) => {
        const customerId = this.$store.state.user.customerId;
        getWallet(customerId)
          .then((res) => {
            this.withdrawAmount = res.data.withdrawAmount;
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    // 获取微信信息
    getBindWechatInfo() {
      return new Promise((resolve, reject) => {
        getBindWechatInfo()
          .then((res) => {
            const data = res.data;
            if (data) {
              this.wechat_info.nickname = data.nickname;
              this.wechat_info.headImgUrl = data.headImgUrl;
            } else {
              Dialog.alert({
                title: "提示",
                message: "您还未绑定微信，请先前往设置-绑定微信",
              }).then(() => {
                this.$router.replace({ name: "Setting" });
              });
            }
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    handleClick() {
      if (this.amount > this.withdrawAmount) {
        Toast.fail("提现金额超出可提现余额");
        return;
      }
      if (this.amount <= 0) {
        Toast.fail("提现金额必须大于0");
        return;
      }
      this.$store.dispatch("app/showLoading");
      payPasswordExists()
        .then((res) => {
          this.$store.dispatch("app/hideLoading");
          if (res.data) {
            this.payPasswordShow = true;
          } else {
            Toast.fail("请前往设置支付密码");
          }
        })
        .catch(() => {
          this.$store.dispatch("app/hideLoading");
        });
    },
    submitForm(password) {
      const params = {
        drawCashAmount: this.amount,
        payPassword: password,
        // drawCashType: "WECHAT"
      };
      this.$store.dispatch("app/showLoading");
      withdraw(params)
        .then((res) => {
          this.$store.dispatch("app/hideLoading");
          this.getData();
          Toast.success("提现成功");
          this.$router.back();
        })
        .catch(() => {
          this.$store.dispatch("app/hideLoading");
          Toast.fail("提现失败");
          this.$router.back();
        });
    },
  },
};
</script>

<style lang="less" scoped>
.withdraw-container {
  padding: 22px 24px;
  .head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    box-shadow: 0px 8px 16px 0px rgba(152, 152, 152, 0.06);
    border-radius: 12px;
    background-color: #fff;
    .label {
      display: flex;
      align-items: center;
      img {
        display: inline-block;
        width: 80px;
        height: 80px;
        margin-right: 20px;
      }
      .text {
        padding-top: 10px;
        .tit {
          font-size: 28px;
          font-weight: 600;
          line-height: 28px;
        }
        .subtit {
          margin-top: 4px;
          font-size: 20px;
          font-weight: 400;
          color: #808080;
          line-height: 28px;
        }
      }
    }
    .value {
      display: flex;
      align-items: center;
      padding-top: 0;
      img {
        display: inline-block;
        width: 28px;
        margin-left: 18px;
      }
    }
  }
  .content {
    padding: 20px;
    margin-top: 20px;
    background-color: #fff;
    box-shadow: 0px 8px 16px 0px rgba(152, 152, 152, 0.06);
    border-radius: 12px;
    .title {
      font-size: 28px;
      font-weight: 400;
      line-height: 28px;
    }
    .value {
      padding-top: 32px;
      .input {
        font-size: 60px;
        line-height: 84px;
        padding: 0 14px;
        /deep/ .van-field__label {
          width: 30px;
          color: #333;
        }
      }
    }
    .tips {
      padding-top: 20px;
      .count {
        font-size: 28px;
        line-height: 28px;
      }
      .btn {
        font-size: 28px;
        color: #0091ff;
        line-height: 28px;
        margin-left: 8px;
      }
    }
  }
  .btn-box {
    padding: 20px 0 42px;
    .btn {
      width: 100%;
      background: #e82035;
      line-height: 80px;
      border-radius: 40px;
      font-size: 28px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      &.disable {
        background-color: #d6d6d6;
        color: #808080;
      }
    }
  }
  .subtips {
    display: flex;
    font-size: 28px;
    font-weight: 400;
    color: #808080;
    line-height: 28px;
    .icon {
      margin-right: 8px;
    }
  }
}
.actionsheet-container {
  padding: 20px 40px 40px;
  .head {
    font-size: 28px;
    font-weight: 400;
    color: #808080;
    line-height: 28px;
  }
  .body {
    .panel {
      padding: 20px 0;
      display: flex;
      img {
        width: 80px;
        height: 80px;
      }
      .value {
        flex: 1;
        min-width: 0;
        padding-left: 20px;
        padding-top: 10px;
        .title {
          font-size: 28px;
          font-weight: 600;
          color: #333333;
          line-height: 28px;
        }
        .desc {
          font-size: 20px;
          font-weight: 400;
          color: #808080;
          line-height: 28px;
          margin-top: 4px;
        }
      }
    }
  }
}
</style>
